import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-regular-svg-icons'
import { getReview } from '../../dataProvider/reviews'

import pic1 from '../../img/v1/home/profile-pic-1.jpg'
import pic2 from '../../img/v1/home/profile-pic-2.jpg'
import pic3 from '../../img/v1/home/profile-pic-3.jpg'
import pic4 from '../../img/v1/home/profile-pic-4.jpg'
import pic5 from '../../img/v1/home/profile-pic-5.jpg'
import pic6 from '../../img/v1/home/profile-pic-6.jpg'
import pic7 from '../../img/v1/home/profile-pic-7.jpg'

import "../../scss/v2/util/customer.scss"

function CustomerReview(props) {

    const pictures = [
        pic1,
        pic2,
        pic3,
        pic4,
        pic5,
        pic6,
        pic7
    ]

    useEffect(() => {
        pictures.forEach((image) => {
            const newImage = new Image();
            newImage.src = image;
            window[image] = newImage;
        });
    })

    const { t } = useTranslation();

    const review = getReview(props.index)

    return (
        <>
            <div className={`customer-review-image-container${props.middle ? ' full-size' : ''}`}>
                {props.noImg ? <></> : <FontAwesomeIcon icon={faUser} />}
                {
                    props.middle && (
                        <div className="customer-review-data">
                            <p className="customer-review-name">{t(review.nameKey)}</p>
                            <p className="customer-review-files">{t('customer.review.totalfiles').replace("<number>", review.totalFiles)}</p>
                        </div>
                    )
                }
            </div>
            <div className="customer-review-header">
                {
                    props.middle && (
                        <div className="customer-review-text-container">
                            <p className="customer-review-text">{t(review.messageKey)}</p>
                        </div>
                    )
                }
            </div>
        </>
    )
}

export default CustomerReview